import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8a6aad6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "유의사항", -1 /* HOISTED */))
const _hoisted_3 = { class: "checkbox-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-area" }, null, -1 /* HOISTED */))
const _hoisted_5 = {
  ref: "listContainer",
  class: "application-list",
  role: "list",
  "aria-label": "신규 노선/정류장 신청 목록"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "empty-content"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "검색결과가 없습니다.", -1 /* HOISTED */))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "modal-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "신규 노선/정류장 신청" }, {
          rightButton: _withCtx(() => [
            _createElementVNode("button", {
              class: "nav-right-wrapper",
              type: "button",
              "aria-label": "유의사항 보기",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowApplicationGuide(true)))
            }, [
              _createVNode($setup["InlineSvg"], {
                src: require('@/assets/icons/help_circle.svg'),
                alt: "유의사항",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, ["src"]),
              _hoisted_2
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode($setup["SearchInput"], {
          class: "search",
          name: "신규 노선/정류장 신청 검색",
          placeholder: "원하시는 지역이나 건물명을 검색하세요",
          value: $setup.searchKeyword,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchKeyword) = $event)),
          delayMilliSeconds: 0,
          onOnEnter: $setup.searchApplication,
          onClearText: $setup.clearSearchKeyword
        }, null, 8 /* PROPS */, ["value"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode($setup["CheckboxInput"], {
            class: "checkbox",
            title: "내 글 보기",
            value: $setup.isMyPostVisible,
            onOnChangedCheck: $setup.toggleIsMyPostVisible
          }, null, 8 /* PROPS */, ["value"]),
          _hoisted_4
        ]),
        _createElementVNode("ul", _hoisted_5, [
          ($setup.applications.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.applications, (application) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: application.uid
                }, [
                  (application.displayYn)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                        _createVNode($setup["NewRouteApplicationRow"], {
                          application: application,
                          onOnClickRow: $setup.goToApplicationDetail
                        }, null, 8 /* PROPS */, ["application"])
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            : (!$setup.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [..._hoisted_9]))
              : _createCommentVNode("v-if", true)
        ], 512 /* NEED_PATCH */),
        _createElementVNode("button", {
          type: "button",
          class: "btn-apply",
          onClick: $setup.onClickApplyBtn
        }, " 신청하기 "),
        ($setup.listContainer)
          ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
              key: 0,
              container: $setup.listContainer
            }, null, 8 /* PROPS */, ["container"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowApplicationGuide,
        onBackHandler: $setup.onClosedNewRouteApplicationGuide
      }, {
        default: _withCtx(() => [
          _createVNode($setup["NewRouteApplicationGuide"], { onOnClickClose: $setup.onClosedNewRouteApplicationGuide })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow"]),
      ($setup.shouldShowDailyWritingCountLimitModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 0,
            title: "작성 횟수 초과",
            okButtonTitle: "확인",
            onOnClickOkButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowDailyWritingCountLimitModal(false)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_10, [
                _createTextVNode(" 하루에 최대 " + _toDisplayString($setup.maxDailyTalkCreationCount ?? "-") + "개의 게시물만 작성할 수 있습니다.", 1 /* TEXT */),
                _hoisted_11,
                _createTextVNode(" 내일 다시 시도해 주세요. ")
              ])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}